import { ReactElement } from 'react';

import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';

import Store from 'lib/Store/withLocalStorage';

import { useUser } from 'hooks/useUser';

import config from 'config/general';
import routes from 'config/routes';

import { checkToken } from 'api/main';

const authStore = Store(`${config.localStorageKey}-auth`);

const RedirectTo = dynamic(() => import('./RedirectTo'), { ssr: false });

function WithMustBeLogged<P extends object>(
  WrappedComponent: React.ComponentType<P>,
): React.ComponentType<P> {
  const ComponentWithHoc = (props: P): ReactElement => {
    const {
      query: { token, subscribed, eventId },
    } = useRouter();

    const { signIn } = useUser();

    if (subscribed === 'false') {
      authStore.setItem(`token`, '');
      authStore.setItem(`isApp`, 'true');
      authStore.setItem(`${config.localStorageKey}-eventId`, (eventId as string) || '');

      return <RedirectTo url={`${routes.notSubscribed}`} />;
    }

    if (token) {
      authStore.setItem(`token`, String(token));
      authStore.setItem(`isApp`, 'true');
      authStore.setItem(`${config.localStorageKey}-eventId`, (eventId as string) || '');

      signIn(String(token));

      return <RedirectTo url={`${routes.home}`} />;
    }

    const validityToken = checkToken();

    if (!validityToken) {
      authStore.setItem(`isApp`, '');
      authStore.setItem(`${config.localStorageKey}-eventId`, (eventId as string) || '');

      return <RedirectTo url={`${routes.auth().login}`} />;
    }

    return <WrappedComponent {...props} />;
  };

  return ComponentWithHoc;
}

export default WithMustBeLogged;
